import { render, staticRenderFns } from "./EditSubCategory.vue?vue&type=template&id=0cd94372&scoped=true&"
import script from "./EditSubCategory.vue?vue&type=script&lang=js&"
export * from "./EditSubCategory.vue?vue&type=script&lang=js&"
import style0 from "./EditSubCategory.vue?vue&type=style&index=0&id=0cd94372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd94372",
  null
  
)

export default component.exports